<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.1596 37.8403C44.2511 31.1248 44.556 19.9319 37.8404 12.8403C31.1249 5.74878 19.932 5.44396 12.8404 12.1595C5.74885 18.8751 5.44403 30.0679 12.1596 37.1595C18.8751 44.2511 30.068 44.5559 37.1596 37.8403Z"
      fill="#E7EEF1"
    />
    <path
      d="M21.945 9.4469L1.78516 29.5626"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M30.5948 42.2141L23.8232 48.993"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M19.7485 35.531L20.7064 42.9583L18.7022 43.872L15.1875 38.0068"
      fill="#E7EEF1"
    />
    <path
      d="M19.7485 35.531L20.7064 42.9583L18.7022 43.872L15.1875 38.0068"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M15.5783 31.3678L8.15098 30.4026L7.2373 32.4068L13.1025 35.9215"
      fill="#E7EEF1"
    />
    <path
      d="M15.5783 31.3678L8.15098 30.4026L7.2373 32.4068L13.1025 35.9215"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M32.5548 21.988L25.2012 29.2238L29.8875 33.9101L34.6401 42.8258L36.7548 42.7963L32.5548 21.988Z"
      fill="#6BFFFF"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M8.31268 14.3544L8.2832 16.4691L17.1989 21.2217L21.8926 25.908L29.121 18.5543L8.31268 14.3544Z"
      fill="#6BFFFF"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M41.6259 9.48384C40.4764 8.33437 36.5196 10.4196 35.3701 11.5691L16.824 30.1153C15.5861 31.3532 10.1703 38.4636 11.4082 39.7015C12.6461 40.9394 19.7492 35.5237 20.9945 34.2858L39.548 15.7322C40.6901 14.5901 42.7754 10.6259 41.6259 9.48384Z"
      fill="white"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M32.6806 31.67L24.8701 39.4879"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>
